import { styled, Grid, Switch } from '@material-ui/core';
import { brand } from '../../theme';

export const AllowDoubleAsteriskField = styled(({ checked, asterisksAllowed, onChange, className, ...p }: any) => {
    const quotaTooLow = (Number(asterisksAllowed) || 0) < 2;
    const subtitle = quotaTooLow
        ? "Requires at least 2 asterisks allowed (a double uses 2)."
        : "Asterisked beer counts ±2 points instead of ±1 (uses 2 asterisks).";
    return (
        <Grid item className={className}>
            <div className={`row${checked ? ' row--on' : ''}${quotaTooLow ? ' row--off' : ''}`}>
                <div className="badge" aria-hidden>
                    <span>⭐</span>
                    <span>⭐</span>
                </div>
                <div className="copy">
                    <div className="title">Allow Double Asterisk</div>
                    <div className="subtitle">{subtitle}</div>
                </div>
                <Switch
                    checked={Boolean(checked)}
                    onChange={(event) =>
                        onChange && onChange({ doubleAsterisk: event.target.checked })
                    }
                    inputProps={{ "data-testid": "doubleAsterisk" } as any}
                    name="doubleAsterisk"
                    color="primary"
                    disabled={quotaTooLow && !checked}
                    {...p}
                />
            </div>
        </Grid>
    );
})(({ theme }) => ({
    marginTop: theme.spacing(2),
    "& .row": {
        background: brand.white,
        border: `1.5px solid ${brand.sep}`,
        borderRadius: 10,
        padding: theme.spacing(1.75, 1.75),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        transition: "border-color .15s",
    },
    "& .row--on": {
        borderColor: brand.amber,
    },
    "& .row--off": {
        opacity: 0.55,
    },
    "& .badge": {
        width: 42,
        height: 42,
        borderRadius: 11,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        background: brand.amberLight,
        fontSize: 14,
    },
    "& .row--on .badge": {
        background: `linear-gradient(135deg, ${brand.amber} 0%, ${brand.amberDeep} 100%)`,
        boxShadow: `0 4px 14px ${brand.amber}55`,
    },
    "& .copy": {
        flex: 1,
        minWidth: 0,
    },
    "& .title": {
        fontSize: 14,
        fontWeight: 700,
        color: brand.text,
    },
    "& .row--on .title": {
        color: brand.amberDark,
    },
    "& .subtitle": {
        fontSize: 12,
        color: brand.textSec,
        marginTop: 2,
        lineHeight: 1.4,
    },
}));
